import { Flow } from 'signup-constants/Flow';
import { FormType } from 'signup-ui-lego-core/constants/FormType';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntegrationOrFlowKey } from '../routing/getIntegrationOrFlowKey';
import { isFlow } from '../utils/isFlow';
import { isCodeVerificationSignup } from '../app/verificationTypeSelectors';
import { getLegalConsentOptionsForSignupRequest } from '../hubspot-forms/form-data-utils/getLegalConsentOptions';
import { getSubmitContext } from '../hubspot-forms/form-data-utils/getSubmitContext';
import Logger from '../lib/Logger';
import { getQueryParams } from '../routing/getQueryParams';
import { Data } from '../signup-data/DATA';
import { getQueryParamsNoSignupData } from '../signup-data/getQueryParamsNoSignupData';
import { getValidatedCompanyDomain } from '../signup-data/getValidatedCompanyDomain';
import { hasPresetOptionalDomain } from '../step-company-domain/companyDomainUtils';
import { getRecaptchaSiteKey, getRecaptchaToken } from '../store/google-recaptcha/selectors';
import { getAccountCreatedFormSurveyData, getFlatSignupDataValueMap } from '../store/signup-data/selectors';
import { getIsNewUser } from '../store/app/selectors';
import { getTalonValue } from '../talon/getTalonValue';
import { getTrialName, getTrialSource } from '../trial/updateFormFieldsTrialInformation';
import { getImpactAdditionalParams } from '../utils/affiliateUtils';
import { parseUtmData } from '../utm/utmHelpers';
import { getAmplitudeEventBody } from '../hubspot-forms/getAmplitudeEventBody';
const LOG = Logger.getLogger('getSignupBody');
export const getSignupBody = state => {
  const talon = getTalonValue();
  const signupData = getFlatSignupDataValueMap(state);
  const flowKey = getFlowKey();
  const userInformation = {
    userInformation: {
      firstName: signupData[Data.FirstName],
      lastName: signupData[Data.LastName],
      password: signupData[Data.Password]
    }
  };
  const FormsApiParams = Object.assign({
    flowKey: getIntegrationOrFlowKey(),
    signupContext: getSubmitContext(FormType.SignupCompleted),
    firstName: signupData[Data.FirstName],
    lastName: signupData[Data.LastName],
    legalConsent: getLegalConsentOptionsForSignupRequest()
  }, isFlow(Flow.Trial) && {
    trialName: getTrialName(),
    trialSource: getTrialSource()
  });
  const queryParams = getQueryParams();
  const queryParamsWithoutSignupData = getQueryParamsNoSignupData(queryParams, signupData);
  const recaptchaToken = getRecaptchaToken(state);
  const recaptchaSiteKey = getRecaptchaSiteKey(state);

  if (!recaptchaToken || !recaptchaSiteKey) {
    LOG.error('Missing recaptcha information', {
      extra: {
        flowKey,
        recaptchaToken,
        recaptchaSiteKey
      }
    });
  }

  const verificationToken = signupData[Data.Token];
  const verificationCode = isCodeVerificationSignup(state) && signupData[Data.CodeVerification];
  const hublet = queryParams['hsReg'] || signupData[Data.HubletSelection];
  const utms = parseUtmData(queryParams);
  const amplitudeEventBody = getAmplitudeEventBody(state);
  return Object.assign({
    isOdyssey: true,
    signupProperties: amplitudeEventBody.signupProperties,
    additionalUrlParams: Object.assign({}, queryParamsWithoutSignupData, {}, utms, {}, getImpactAdditionalParams(), {
      flowPath: flowKey
    }, hublet && {
      hsReg: hublet
    }),
    companyName: signupData[Data.CompanyName],
    domain: getValidatedCompanyDomain(signupData[Data.CompanyDomain]),
    email: signupData[Data.Email]
  }, verificationToken && {
    verificationToken
  }, {}, verificationCode && {
    verificationCode
  }, {}, signupData[Data.Password] && userInformation, {
    languageOptions: amplitudeEventBody.languageOptions,
    recaptchaToken,
    recaptchaSiteKey,
    talon,
    useNewDomainErrorMessages: true
  }, FormsApiParams, {
    surveyData: getAccountCreatedFormSurveyData(state),
    queryParams: Object.assign({}, queryParamsWithoutSignupData, {}, utms)
  }, amplitudeEventBody.referrerData && {
    referrerData: amplitudeEventBody.referrerData
  }, {}, amplitudeEventBody.utms && {
    utms: amplitudeEventBody.utms
  }, {}, amplitudeEventBody.experimentParameters && {
    experimentParameters: amplitudeEventBody.experimentParameters
  }, {
    applicationId: amplitudeEventBody.applicationId,
    placeholderDomainExperience: hasPresetOptionalDomain(state),
    signupVerificationType: amplitudeEventBody.signupVerificationType,
    newUser: getIsNewUser(state)
  });
};